export default "__VITE_ASSET__CF_d7i$D__"